/**
 * Width of the fixed label slot beside a usage meter, in `ch` of the label's
 * own font: the longest label in the column plus a little air.
 *
 * Every row in a column gets the same slot, right-aligned, so every meter track
 * starts and ends at the same x however wide that row's own figures are. With
 * tabular figures each digit is one `ch`; the other glyphs in these labels
 * ("of", "h", ",", ".") are no wider, and `extra` covers a wide glyph like "%".
 */
export const labelSlotWidth = (labels: string[], extra = 0.5): string => {
  const longest = labels.reduce((max, label) => Math.max(max, label.length), 0);
  return longest > 0 ? `${longest + extra}ch` : 'auto';
};
